import { encodeFieldsToBase64 } from '/src/common/general-utils';
import { widgetForApi, widgetForState, fieldsToEncode } from './../widget-helper';
export const actions = {
  /**
   * Method to fetch widget
   */
  async getWidget({ commit }, widgetUUID) {
    let widget;
    try {
      widget = await this.$axios.$get(`/api/v2/widgets/${widgetUUID}/byRef`);
      commit('setWidget', widgetForState(widget));
    } catch (error) {
      this.$toast.error(
        this.$errorFromResponse(
          this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.fetch_action', {
            feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.widgets')
          }),
          error
        )
      );
    }
    return widget;
  },

  async saveWidgetBasic({ commit }, widget) {
    let widgetToSave = widgetForApi(widget);
    widgetToSave = encodeFieldsToBase64(widgetToSave, fieldsToEncode);

    await this.$axios.$post(`/api/v2/widgets/${widget.UUID}/update`, widgetToSave);
    this.$toast.success(
      this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.save_success', {
        feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.widgets')
      })
    );
    /**
     * Copy the previous widget with changed data to avoid prompt on save widget.
     */
    commit('setPreviousWidget', widget);
  },

  /**
   * Method to save widget
   */
  async saveWidget({ dispatch }, widget) {
    try {
      await dispatch('saveWidgetBasic', widget);
      navigateTo({
        name: 'admin-dashboards-design-UUID',
        params: { UUID: widget.PageRef }
      });
    } catch (error) {
      this.$toast.error(
        this.$errorFromResponse(
          this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.saving_action', {
            feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.widgets')
          }),
          error
        )
      );
    }
  },
  /**
   * Method to get business rules for dropdown
   */
  async getBusinessRules({ commit, dispatch }, { searchValue, selectedValue, fetchKPI = true }) {
    try {
      let queryParams = {
        params: {
          searchBusinessRule: searchValue,
          businessRules: selectedValue ? `["${selectedValue}"]` : ''
        }
      };
      commit(
        'setBusinessRules',
        await this.$axios.$get(
          `/api/v2/business-rules/withFields?fields=["UUID","Name","DataTableName","WorkflowUUID","FieldConfig"]`,
          queryParams
        )
      );
      if (fetchKPI) {
        dispatch('getKpis', selectedValue);
      }
      dispatch('fetchTableFields', selectedValue);
    } catch (error) {
      this.$toast.error(
        this.$errorFromResponse(
          this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.fetch_action', {
            feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.businessrule')
          }),
          error
        )
      );
    }
  },
  /**
   * Method to get kpis for dropdown
   */
  async getKpis({ commit }, businessRule) {
    if (businessRule) {
      try {
        const kpis = await this.$axios.$get(`/api/kpis/${businessRule}/queryByRuleRef`);
        commit('setKpis', kpis);
        commit('setKpisLoadingStatus', true);
      } catch (error) {
        this.$toast.error(
          this.$errorFromResponse(
            this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.fetch_action', {
              feature: this.vueApp.$nuxt.$i18n.global.t('common.businessrules.kpis.header')
            }),
            error
          )
        );
      }
    }
  },
  /**
   * Method to get datamodel for selected businessrule
   */
  async getDataModel({ commit }, dataModelName) {
    if (dataModelName) {
      try {
        const dataModelUUID = await this.$axios.$get(`/api/admin/models/byName/${dataModelName}`);
        commit('setDataModel', { dataModelName, dataModelUUID });
      } catch (error) {
        this.$toast.error(
          this.$errorFromResponse(
            this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.fetch_action', {
              feature: this.vueApp.$nuxt.$i18n.global.t('common.businessrules.data_model')
            }),
            error
          )
        );
      }
    }
  },
  /**
   * Reset selected kpis, dimensions based on selected business rule
   */
  reloadKpis({ commit, dispatch }, businessRuleUuid) {
    commit('resetBrDependentLists');
    commit('resetFields');
    commit('resetDataTableFields');
    dispatch('getKpis', businessRuleUuid);
  },

  async fetchTableFields({ commit, getters, state }, businessRule) {
    if (businessRule) {
      // Always resolve and commit BusinessRuleFieldConfig so alias-aware
      // components (dimension dropdowns, column headers) work on first creation.
      const rule = state.businessRules?.find?.((r) => r.UUID === businessRule);
      if (rule?.FieldConfig) {
        const fieldConfig = typeof rule.FieldConfig === 'string' ? rule.FieldConfig.sParseJSON() : rule.FieldConfig;
        commit('setWidgetProperty', { prop: 'BusinessRuleFieldConfig', value: fieldConfig });
      } else {
        commit('setWidgetProperty', { prop: 'BusinessRuleFieldConfig', value: [] });
      }

      // if available fetching from state
      if (state.businessRuleFieldsMap[businessRule]) {
        commit('setBusinessRuleColumn', state.businessRuleFieldsMap[businessRule]);
        commit('setFieldsLoadingStatus', true);
        return;
      }
      try {
        const tableName = getters.getBusinessRuleTable(businessRule);
        const fields = await this.$axios.$get(`/api/profiler-table`, { params: { tableName: tableName } });
        commit('setBusinessRuleColumn', fields);
        // also set it in map
        commit('setFieldsMap', { uuid: businessRule, fields });
        commit('setFieldsLoadingStatus', true);
      } catch (error) {
        this.$toast.error(
          this.$errorFromResponse(
            this.vueApp.$nuxt.$i18n.global.t('admin.widgets.edit_widget.error_fetching_column', {
              feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.dashboard')
            }),
            error
          )
        );
      }
    }
  }
};
